"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderCell = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classNameBuilders_1 = require("../../../lib/classNameBuilders");
const FilesTableContext_1 = require("../FilesTableContext");
const elements_1 = require("../../../elements");
const HeaderCell = ({ column }) => {
    const ctx = (0, react_1.useContext)(FilesTableContext_1.FilesTableContext);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, classNameBuilders_1.bem)('table__header-cell', (0, classNameBuilders_1.use)(column.sortable, '--sortable')), style: { maxWidth: column.width }, onClick: () => {
            if (column.sortable && ctx.onOrderChange) {
                if (ctx.order && ctx.order.column === column.name) {
                    ctx.onOrderChange({
                        column: column.name,
                        direction: ctx.order.direction === 'ASC' ? 'DESC' : 'ASC'
                    });
                }
                else {
                    ctx.onOrderChange({
                        column: column.name,
                        direction: 'ASC'
                    });
                }
            }
        } }, { children: [column.header(), column.sortable && ctx.order && ctx.order.column === column.name && ((0, jsx_runtime_1.jsx)(elements_1.Icon, { className: "ml--0_25", name: ctx.order.direction === 'ASC' ? 'arrowUp' : 'arrowDown' }, void 0))] }), void 0));
};
exports.HeaderCell = HeaderCell;
//# sourceMappingURL=HeaderCell.js.map